"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogFooter = exports.DialogBody = exports.DialogTitle = exports.DialogClose = exports.DialogHeader = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = __importDefault(require("../../theme"));
var Close_1 = __importDefault(require("../../icons/Close"));
var styles_1 = require("./styles");
function DialogHeader(_a) {
    var children = _a.children, style = _a.style, className = _a.className;
    var childrenCount = react_1.Children.count(children);
    return (react_1.default.createElement(styles_1.DialogBaseHeader, { childrenCount: childrenCount, className: className, style: style }, children));
}
exports.DialogHeader = DialogHeader;
function DialogClose(_a) {
    var className = _a.className, style = _a.style, props = __rest(_a, ["className", "style"]);
    return (react_1.default.createElement(styles_1.DialogBaseCloseButton, __assign({}, props, { className: className, style: style }),
        react_1.default.createElement(Close_1.default, { color: theme_1.default.colorsPalette.gray.light, height: "12px" })));
}
exports.DialogClose = DialogClose;
exports.DialogTitle = styled_components_1.default.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  color: ", ";\n  font-size: ", ";\n  font-weight: 700;\n"], ["\n  margin: 0;\n  color: ", ";\n  font-size: ", ";\n  font-weight: 700;\n"])), theme_1.default.colorsPalette.gray.darker, theme_1.default.fontSizes.regularLarge);
exports.DialogBody = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  overflow-y: scroll;\n\n  p {\n    color: ", ";\n  }\n"], ["\n  width: 100%;\n  overflow-y: scroll;\n\n  p {\n    color: ", ";\n  }\n"])), theme_1.default.colorsPalette.gray.default);
exports.DialogFooter = styled_components_1.default.footer(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 24px;\n  width: 100%;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 24px;\n  width: 100%;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=components.js.map